/// <reference path="./images.d.ts" />
// Images
import logo from './appLogo.png';
import appStore from './appStore.png';
import googlePlay from './googlePlay.png';
import Catimg from './CatImg.png';
import Container from './container.png';
import Wishlist from './wishlist.png';
import ArrowRight from './arrowup.png';
import Google from './google.png';
import Phone from './phone.png';
import Apple from './apple.png';
import Cross from './cross.png';
import ModalLogo from './modallogo.png';
import Instagram from "./instagram.png";
import Facebook from "./facebook.png";
import Contact from "./contact.png";
import logowithouttext from "./appLogo_without_text.png";
// import trailer2 from "../../../src/assets/images/trailer2."

// Export them al
export const images = {
  logo,
  appStore,
  googlePlay,
  Catimg,
  Container,
  Wishlist,
  ArrowRight,
  Google,
  Phone,
  Apple,
  Cross,
  ModalLogo,
  Instagram,
  Facebook,
  Contact,
  logowithouttext
};